/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Whisper Transcription Service API
 * OpenAPI contract for the Whisper transcription service. This defines the interface between the Kotlin backend and the Python Whisper service for audio transcription with speaker diarization.  ## Authentication  The service uses Firebase JWT tokens for authentication. Include the token in the `Authorization` header as a Bearer token: ``` Authorization: Bearer <firebase-id-token> ```  Internal endpoints (`/internal/_*`) use service-to-service authentication via the `X-Service-Key` header.  ## Audio Upload Patterns  ### File Upload (Pre-recorded) 1. Call `POST /api/v1/uploads/initiate` to get a signed URL 2. Upload directly to GCS using the signed URL (resumable upload) 3. GCS Object Finalize event triggers processing automatically 4. The Kotlin backend fetches results via the internal `GET /internal/transcripts/{id}` endpoint  ### Live Recording (WebSocket) Connect to `wss://whisper.scrivio.nl/api/v1/recordings/live` with the Firebase token.  #### WebSocket Message Format  **Client → Server:** ```json {   \"type\": \"audio\",   \"data\": \"<base64-encoded-pcm-audio>\" } ``` Audio format: 16kHz, mono, Int16 PCM (no container format).  ```json {   \"type\": \"end\" } ``` Signals end of recording.  **Server → Client:** ```json {   \"type\": \"partial\",   \"text\": \"Partial transcription...\" } ``` Real-time partial transcription (may change).  ```json {   \"type\": \"segment\",   \"segment\": {     \"speakerLabel\": 0,     \"text\": \"Final segment text\",     \"startTimeMs\": 0,     \"endTimeMs\": 2500   } } ``` Finalized transcript segment.  ```json {   \"type\": \"complete\",   \"transcriptId\": \"550e8400-e29b-41d4-a716-446655440000\" } ``` Transcription completed; use the ID to fetch full results.  ```json {   \"type\": \"error\",   \"message\": \"Error description\" } ``` Processing error occurred. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8000".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
